(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vondilo-concept"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-vx]').forEach(root=>{const home=root.querySelector('[data-home]'),detail=root.querySelector('[data-details]'),cards=[...root.querySelectorAll('.vx-card')],grid=root.querySelector('.vx-grid'),input=document.querySelector('#vx-search-input'),count=root.querySelector('.vx-count'),empty=root.querySelector('.vx-empty'),sort=root.querySelector('[data-sort]');let category='Alles';const original=[...cards];function apply(){let n=0;const term=input.value.trim().toLocaleLowerCase('nl');cards.forEach(card=>{card.hidden=(category!=='Alles'&&card.dataset.category!==category)||(term&&!card.textContent.toLocaleLowerCase('nl').includes(term));if(!card.hidden)n++});root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.filter===category)));count.textContent=n+' uitgelicht'+(n===1?' product':'e producten')+(term?' voor “'+input.value.trim()+'”':'');empty.hidden=n!==0;let arranged=sort.value==='default'?original:[...cards].sort((a,b)=>sort.value==='name'?a.querySelector('h3').textContent.localeCompare(b.querySelector('h3').textContent,'nl'):sort.value==='low'?Number(a.dataset.price)-Number(b.dataset.price):Number(b.dataset.price)-Number(a.dataset.price));arranged.forEach(card=>grid.appendChild(card))}root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;apply()}));root.querySelectorAll('[data-category-link]').forEach(a=>a.addEventListener('click',()=>{category=a.dataset.categoryLink;input.value='';apply()}));input.addEventListener('input',()=>{if(!input.value)apply()});sort.addEventListener('change',apply);root.querySelector('[data-reset]').addEventListener('click',()=>{category='Alles';input.value='';sort.value='default';apply()});apply();});

  } catch(e) { console.error(e); }
})();
})();
